import L from 'leaflet';
import PropTypes from 'prop-types';

import useLeafletLayer from './useLeafletLayer';

function LeafletTileLayer(props) {
  const { url, ...options } = props;

  useLeafletLayer(() => L.tileLayer(url, options));

  return null;
}

LeafletTileLayer.propTypes = {
  url: PropTypes.string.isRequired,
  attribution: PropTypes.string,
  maxZoom: PropTypes.number,
  // Tiles exist up to this zoom; beyond it the map enlarges them
  maxNativeZoom: PropTypes.number,
  className: PropTypes.string,
};

export default LeafletTileLayer;
